import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Fragment } from "react";



//
import Card from '../../../component/Layout/theme/card'
import PageChange from "../../../pageChange/index";
import Layout from '../../../component/Layout/Layout'




///
import { GetMethod, PutMethod } from "../../../helper/Api";


//
import { Input } from "../../../component/form/input";
import toast from "react-hot-toast";


function EditQrcode() {

    const { id } = useParams();
    const { token, login } = useSelector((item) => item.user);


    ///////
    const [fullName, setFullNames] = useState("")
    const [site, setSite] = useState("")
    const [hint, setHint] = useState("")
    const [instagramUsername, setInstagramUsername] = useState("")
    const [call, setCall] = useState("")
    //////



    const [isDataLoad, SetIsDataLoad] = useState(false);
    const [optionsCheck, setOptionsCheck] = useState(false)



    let params = useParams();
    var { t } = useTranslation();


    const [disableButton, setDisableButton] = useState(false)


    const [data, setData] = useState()



    useEffect(() => {
        document.title = t("create_augmented_reality");
        const getData = async () => {
            var url = `/api/nft/edit/${id}`;

            const res = await GetMethod({ url: url, token: token })

            if (res.status === "success") {
                setFullNames(res.data.name)
                setSite(res.data.site)
                setHint(res.data.hint)
                setInstagramUsername(res.data.instagram)
                setCall(res.data.call)
                setData(res.data)
                SetIsDataLoad(true);
            }

        }
        if (login === false) {
            window.location.href = "/login"
        }
        getData();
    }, [login]);





    const submitForm = async () => {

        if (fullName.length === 0) {
            toast.error(t("please_fill_name_validation"))
        }
        else {

            setDisableButton(true)
            const userData = {
                name: fullName,
                site: site,
                hint: hint,
                instagramUsername: instagramUsername,
                call: call
            };

            var url = `/api/nft/edit/${id}`;

            await PutMethod(
                { url: url, body: userData, token: token },
                (res) => {
                    if (res.status === "success") {
                        toast.error(t("mission_was_successful"))
                        window.history.back();
                        setTimeout(() => {
                            window.location.reload();
                        }, 500);
                        setDisableButton(false)
                    }
                },
                (error) => {
                    toast.error(error);
                    console.log(error, "error")
                    setDisableButton(false)

                }
            );
        }

    };



    // زدن اینتر
    function enterKeyPress(e) {
        if (e.key === "Enter") {
            // submitForm(e);
            // startUpload(e);
            // discountCode(e)
        }
    }

    const [bodyWidth, setBodyWidth] = useState(null);


    useEffect(() => {
        const handleResize = () => {
            setBodyWidth(document.body.offsetWidth);
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleResize = (bodyWidth) => {
        if (bodyWidth < 1024) {
            return "max-w-screen-2xl  px-6 sm:px-8 lg:px-16 mx-auto";
        } else {
            return "w-max-w-screen-2xl  px-6 sm:px-8 lg:px-16 mx-auto rounded-lg"
        }
    };


    useEffect(() => {
        handleResize(bodyWidth)
    }, []);




    return (
        <>
            {
                isDataLoad
                    ?
                    (
                        <>
                            <Layout />

                            <div className="flex flex-col gap-5 mb-24 lg:grid lg:grid-cols-2">
                                <div className="order-2 space-y-5 lg:order-1">
                                    <Card className={handleResize(bodyWidth)} >
                                        <div className="p-5 mb-24 space-y-4 bg-white rounded-lg shadow-md">
                                            {/* /formName */}
                                            <div className="relative">
                                                <Input
                                                    placeholder={t("names")}
                                                    id="nameTest"
                                                    onChange={(e) => setFullNames(e.target.value)}
                                                    value={fullName !== null ? fullName : ''}
                                                />
                                            </div>
                                            {/*  Options  */}
                                            {
                                                params.id === "price_personal"
                                                    ?
                                                    (
                                                        ""
                                                    )
                                                    :
                                                    <div className="space-y-2 mt-6 flex w-[100%] cursor-pointer font-bold text-gray-500">
                                                        <div onClick={() => setOptionsCheck(!optionsCheck)}>{optionsCheck ? `${t("fewer_settings")}` : `${t("more_settings")}`}</div>
                                                    </div>
                                            }
                                            {
                                                optionsCheck
                                                &&
                                                (
                                                    <>
                                                        <div className="relative mt-2 ">
                                                            <Input
                                                                placeholder={t("site_link")}
                                                                id="site"
                                                                onChange={(e) => setSite(e.target.value)}
                                                                value={site !== null ? site : ''}
                                                            />
                                                        </div>
                                                        <div className="relative mt-3">
                                                            <Input
                                                                placeholder={t("help_site")}
                                                                id="hint"
                                                                onChange={(e) => setHint(e.target.value)}
                                                                value={hint !== null ? hint : ''}
                                                            />
                                                        </div>
                                                        <div className="relative mt-3">
                                                            <Input
                                                                placeholder={t("instagram_username")}
                                                                id="instagram"
                                                                onChange={(e) => setInstagramUsername(e.target.value)}
                                                                value={instagramUsername !== null ? instagramUsername : ''}
                                                            />
                                                        </div>
                                                        <div className="relative mt-3">

                                                            <Input
                                                                placeholder={t("phone_number")}
                                                                id="call"
                                                                onChange={(e) => setCall(e.target.value)}
                                                                value={call !== null ? call : ''}
                                                            />
                                                        </div>

                                                    </>
                                                )
                                            }

                                            <button
                                                className="w-full h-10 mt-2 text-white bg-blue-500 rounded-lg"
                                                type="submit"
                                                disabled={disableButton ? true : false}

                                                onClick={() => submitForm()}
                                                onKeyPress={(e) => enterKeyPress(e)}
                                            >
                                                {t("edit")}
                                            </button>
                                        </div>

                                    </Card>

                                </div>
                                {/* /add images and videos */}

                                <Card className={`${handleResize(bodyWidth)} order-1 lg:order-2 w-full`} >
                                    <div className="p-5 mb-24 space-y-4 bg-white rounded-lg shadow-md">
                                        <div className="text-sm font-bold text-center">
                                            <p>{t("your_video_photos")}</p>
                                        </div>
                                        {/* key={index} */}
                                        <Fragment  >
                                            <div
                                                className=""
                                            >
                                                {
                                                    data.image && data.image.map((item, index) => {
                                                        return (

                                                            <div className="flex flex-col items-center justify-center gap-4" key={index}>

                                                                <div className="border border-gray-300 rounded">
                                                                    <img
                                                                        src={`${process.env.REACT_APP_SERVER}/uploads/${data.users.username}/image/${item}`}
                                                                        className="w-[100px] h-[100px] object-cover !min-h-[1rem]"
                                                                    />
                                                                </div>

                                                                <div className="grid gap-2 text-sm font-normal text-gray-800 place-items-center">
                                                                    <span className="">{t("video")} :</span>
                                                                    <p className="overflow-hidden truncate" dir="ltr">{data.video[index]}</p>

                                                                </div>

                                                                <div className="flex flex-col items-center gap-2">
                                                                    <Link to={`/qrcode/editvideo/${id}/${index}`}>
                                                                        <button
                                                                            className="w-full h-10 px-5 text-white bg-blue-500 rounded-lg"
                                                                            type="submit"
                                                                        >
                                                                            {t("edit")}
                                                                        </button>
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        )

                                                    })
                                                }

                                            </div>
                                        </Fragment>

                                    </div>
                                </Card>


                            </div>

                        </>
                    )
                    :
                    <PageChange />
            }

        </>
    )
}

export default EditQrcode